var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"genGrid"},[_c('button',{staticClass:"btn",attrs:{"id":"logoutBtn"},on:{"click":function($event){return _vm.logout(_vm.loginToken)}}},[_c('p',[_vm._v(" logout ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }